(function() {
  'use strict';
  
  function initVariantCards() {
    const productGrid = document.querySelector('#product-grid');
    if (!productGrid) return;
    
    const allProductCards = Array.from(productGrid.querySelectorAll('.grid__item'));
    
    // First, collect variant URLs by triggering G Combined Listing
    const productVariantsPromises = allProductCards.map(async (originalCard) => {
      const productHandle = originalCard.querySelector('[p-handle]')?.getAttribute('p-handle');
      const colorContainer = originalCard.querySelector('.mpg-swatch__option-set[os-name="Color"]');
      
      if (!colorContainer) {
        return {
          handle: productHandle,
          variants: [{
            card: originalCard,
            url: originalCard.querySelector('a[href*="/products/"]')?.href
          }]
        };
      }
      
      const colorOptions = Array.from(colorContainer.querySelectorAll('.mpg-swatch__option[o-name="Color"]'));
      
      if (colorOptions.length <= 1) {
        return {
          handle: productHandle,
          variants: [{
            card: originalCard,
            url: originalCard.querySelector('a[href*="/products/"]')?.href
          }]
        };
      }
      
      const variants = [];
      const seenColors = new Set();
      
      for (const colorOption of colorOptions) {
        const colorValue = colorOption.getAttribute('o-value');
        
        if (seenColors.has(colorValue)) continue;
        seenColors.add(colorValue);
        
        // Click the color option to let G Combined Listing update the card
        colorOption.click();
        
        // Wait a tiny bit for G Combined Listing to update
        await new Promise(resolve => setTimeout(resolve, 50));
        
        // Now get the updated URL
        const productLink = originalCard.querySelector('a[href*="/products/"]');
        const variantUrl = productLink ? productLink.href : null;
        
        // Clone the card
        const clonedCard = originalCard.cloneNode(true);
        const colorBgImage = colorOption.querySelector('div[style*="background-image"]');
        
        // Pre-select this color
        const clonedColorOptions = clonedCard.querySelectorAll('.mpg-swatch__option[o-name="Color"]');
        clonedColorOptions.forEach(opt => {
          if (opt.getAttribute('o-value') === colorValue) {
            opt.classList.add('selected');
          } else {
            opt.classList.remove('selected');
          }
        });
        
        const colorLabel = clonedCard.querySelector('.mpg-swatch__label-value');
        if (colorLabel) {
          colorLabel.textContent = colorValue;
        }
        
        // Update main product image
        if (colorBgImage) {
          const bgStyle = colorBgImage.style.backgroundImage;
          const urlMatch = bgStyle.match(/url\(['"]?([^'"]+)['"]?\)/);
          if (urlMatch) {
            let imageUrl = urlMatch[1].replace(/\?width=\d+/, '');
            const mainImg = clonedCard.querySelector('.card__media img');
            if (mainImg) {
              mainImg.src = imageUrl;
              mainImg.srcset = imageUrl;
            }
          }
        }
        
        // Update all links with the captured variant URL
        if (variantUrl) {
          const productLinks = clonedCard.querySelectorAll('a[href*="/products/"]');
          productLinks.forEach(link => {
            link.href = variantUrl;
          });
          console.log(`✅ ${colorValue}: ${variantUrl}`);
        }
        
        variants.push({
          card: clonedCard,
          color: colorValue,
          url: variantUrl
        });
      }
      
      return {
        handle: productHandle,
        variants: variants
      };
    });
    
    // Wait for all variants to be collected
    Promise.all(productVariantsPromises).then(productVariants => {
      // Distribute ALL variants using round-robin through color positions
      const finalCardsList = [];
      let globalColorIndex = 0;
      
      const maxVariants = Math.max(...productVariants.map(p => p.variants.length));
      
      for (let round = 0; round < maxVariants; round++) {
        productVariants.forEach((product) => {
          const variants = product.variants;
          const colorPosition = globalColorIndex % variants.length;
          
          if (variants[colorPosition]) {
            finalCardsList.push(variants[colorPosition].card);
          }
          
          globalColorIndex++;
        });
      }
      
      console.log(`✅ Created ${finalCardsList.length} cards with variant URLs`);
      
      // Render cards
      productGrid.innerHTML = '';
      finalCardsList.forEach((card, index) => {
        card.style.setProperty('--index', index);
        productGrid.appendChild(card);
      });
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(initVariantCards, 2000);
    });
  } else {
    setTimeout(initVariantCards, 2000);
  }
})();